"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponsDataProvider = function () {
  function CouponsDataProvider(Coupons) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CouponsDataProvider);
    this.CouponsService = Coupons;
  }

  (0, _createClass3.default)(CouponsDataProvider, [{
    key: "getCoupons",
    value: function getCoupons(data) {
      return this.CouponsService.loadCoupons(data).then(function (result) {
        return result;
      });
    }
  }, {
    key: "getCoupon",
    value: function getCoupon(id) {
      return this.CouponsService.getCoupon(id).then(function (result) {
        return result;
      });
    }
  }, {
    key: "updateCoupon",
    value: function updateCoupon(data, id) {
      return this.CouponsService.updateCoupon(data, id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "updateCouponStatus",
    value: function updateCouponStatus(data) {
      return this.CouponsService.updateCouponStatus(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "removeCoupon",
    value: function removeCoupon(id) {
      return this.CouponsService.removeCoupon(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "createCoupon",
    value: function createCoupon(data) {
      return this.CouponsService.createCoupon(data).then(function (resp) {
        return resp;
      });
    }
  }]);
  return CouponsDataProvider;
}();

// WEBPACK FOOTER //


exports.default = CouponsDataProvider;


/** WEBPACK FOOTER **
 ** ./client/app/modules/coupons/services/coupon.dataprovider.service.js
 **/